import { render, staticRenderFns } from "./CadastroEtapa.vue?vue&type=template&id=380789f8"
import script from "./CadastroEtapa.vue?vue&type=script&lang=js"
export * from "./CadastroEtapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports